import { db } from "@/firebase"
import firebase from "firebase"

export default {
  state: {
    loading: false
  },
  getters: {},
  mutations: {
    toggleLoading(state) {
      state.loading = !state.loading
    }
  },
  actions: {
    uploadFileToStorageAndUser({ commit }, payload) {
      commit("toggleLoading")
      let uploadData = {
        userId: payload.userId,
        fileName: payload.fileName,
        file: payload.file
      }
      firebase
        .storage()
        .ref("users/" + uploadData.fileName)
        .put(uploadData.file)
        .then(fileData => {
          return fileData.ref
            .getDownloadURL()
            .then(fileUrl => {
              const file = {
                name: uploadData.fileName,
                url: fileUrl
              }
              return db
                .collection("users")
                .doc(uploadData.userId)
                .update({
                  files: firebase.firestore.FieldValue.arrayUnion(file)
                })
              // .update({
              //   file: fileUrl
              // })
            })
            .then(() => {
              commit("toggleLoading")
            })
        })
    },
    uploadFileToStorageAndOpdracht({ commit }, payload) {
      commit("toggleLoading")
      let uploadData = {
        opdrachtId: payload.opdrachtId,
        fileName: payload.fileName,
        file: payload.file
      }
      firebase
        .storage()
        .ref("opdrachten/" + uploadData.fileName)
        .put(uploadData.file)
        .then(fileData => {
          return fileData.ref
            .getDownloadURL()
            .then(fileUrl => {
              const file = {
                name: uploadData.fileName,
                url: fileUrl
              }
              return db
                .collection("opdrachten")
                .doc(uploadData.opdrachtId)
                .update({
                  files: firebase.firestore.FieldValue.arrayUnion(file)
                })
              // .update({
              //   file: fileUrl
              // })
            })
            .then(() => {
              commit("toggleLoading")
            })
        })
    },
    deleteFileFromStorageAndUser({ commit }, payload) {
      commit("toggleLoading")
      const deleteData = {
        userId: payload.userId,
        fileUrl: payload.fileUrl,
        fileName: payload.fileName,
        files: payload.files
      }
      firebase
        .storage()
        .ref("users/" + deleteData.fileName)
        .delete()
        .then(() => {
          return db
            .collection("users")
            .doc(deleteData.userId)
            .update({
              files: deleteData.files.filter(file => file.url !== deleteData.fileUrl)
            })
        })
        .then(() => {
          commit("toggleLoading")
        })
    },
    deleteFileFromStorageAndOpdracht({ commit }, payload) {
      commit("toggleLoading")
      const deleteData = {
        opdrachtId: payload.opdrachtId,
        fileUrl: payload.fileUrl,
        fileName: payload.fileName,
        files: payload.files
      }
      firebase
        .storage()
        .ref("opdrachten/" + deleteData.fileName)
        .delete()
        .then(() => {
          return db
            .collection("opdrachten")
            .doc(deleteData.opdrachtId)
            .update({
              files: deleteData.files.filter(file => file.url !== deleteData.fileUrl)
            })
        })
        .then(() => {
          commit("toggleLoading")
        })
    }
  }
}
